import React from 'react';

const OrderNoteSection = ({ 
  isOrderNoteChecked, 
  setIsOrderNoteChecked, 
  isOrderNoteText, 
  setIsOrderNoteText 
}) => {
  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-header bg-white py-3">
        <h4 className="mb-0 fs-5">
          <i className="fas fa-sticky-note me-2"></i>
          Order Note
        </h4>
      </div>
      <div className="card-body">
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="note"
            checked={isOrderNoteChecked}
            onChange={(e) => setIsOrderNoteChecked(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="note">
            Add Order Note
          </label>
        </div>
        {isOrderNoteChecked && (
          <textarea
            className="form-control"
            onChange={(e) => setIsOrderNoteText(e.target.value)}
            value={isOrderNoteText}
            placeholder="Add special instructions for your order..."
            rows="3"
            maxLength={500}
            style={{ minHeight: "120px", resize: "vertical" }}
          ></textarea>
        )}
      </div>
    </div>
  );
};

export default OrderNoteSection;
